import api from "../../api/api";

//Modules Api
export const getAllModules = async (data) =>
  await api.get(`getAllModules/training/${data.usertype}/${data.language}`);

export const createAllModules = async (data) =>
  await api.post(`createNewModule`, data);

export const updateModules = async (data) =>
  await api.put(`updateModule/`, data);

export const deleteModules = async (moduleid) =>
  await api.delete(`deleteModule/${moduleid}`);

//Submodules Api

export const getAllSubModules = async (data) =>
  await api.get(
    `getAllSubmodulesByModuleid/training/${data.usertype}/${data.language}/${data.moduleid}`
  );

export const createAllSubModules = async (data) =>
  await api.post(`createNewSubmodule`, data);

export const updateSubModules = async (data) =>
  await api.put(`updateSubModule/`, data);

export const deleteSubModules = async (submoduleid) =>
  await api.delete(`deleteSubModule/${submoduleid}`);

//Topics Api

export const getAllTopics = async (data) =>
  await api.get(
    `getAllTopicsBySubmoduleid/training/${data.usertype}/${data.language}/${data.moduleid}/${data.submoduleid}`
  );

export const createAllTopics = async (data) =>
  await api.post(`createNewTopic`, data);

export const updateTopics = async (data) => await api.put(`updateTopic/`, data);

export const deleteTopics = async (topicid) =>
  await api.delete(`deleteTopic/${topicid}`);
